export const AppRoutes = {
	home: '/home',
	gift: '/pages/gift',
	productsAndServices: '/productsAndServices',
	contactUs: '/contact-us',
}

export const AuthRoutes = {
	login: '/login',
	register: '/auth/register',
	forgotPassword: '/auth/forgot-password',
};

export const ContractRoutes = {
	contract: '/contract-query',
	contract_fn: '/admin/contract-query',
	contract_detail: '/contract-query-detail',
	contract_detail_fn: '/admin/contract-query-detail',
	product_detail: '/contract-query/product-detail',
	payment: '/contract-query/payment',
	payment_fn: '/admin/contract-query/payment',
	change_condition: '/change-condition',
	change_condition_fn: '/admin/change-condition',
	benefit: '/benefit',
	benefit_fn: '/admin/benefit',
  contract_master: '/master-contract',
  contract_master_fn: '/admin/master-contract',
  free_master: '/free_master',
  free_master_fn: '/admin/free_master',
  ebill_master: '/ebill_master',
  ebill_master_fn: '/admin/ebill_master',
  due_freemaster: '/due_freemaster',
  due_freemaster_fn: '/admin/due_freemaster',
  //group_product: '/pages/group-product',
};


export const RoutesV1 = {
	// premium payment
	premiumPayment: '/pages/premium-payment',
	premiumPayment_fn: '/pages/admin/premium-payment',
	// System manager
	functionSupport: '/pages/function-support',
	groupProduct: '/pages/group-product',
	catParamConfig: '/pages/cat-param-config',
	categoryMenu: '/pages/category-menu',
	premiumPaymentStatus: '/pages/premium-payment-status',
	manageJob: '/pages/manage-job',
	mobileAppUpdate: '/pages/mobile-app-update',
	log: '/pages/log',
	notifyManager: '/pages/notify-manager',
	// Account manager
	manageAccountInfo: '/pages/manage-account-info',
	manageMerchant: '/pages/manage-merchant',
	createNewAccount: '/pages/create-new-account',
	roleMenu: '/pages/role-menu',
	userRole: '/pages/user-role',
	//update profile
	updateAccountInfo: '/pages/update-account-info',
	accountInfo: '/pages/account-info',

	// insurance
	insuranceOnline: '/pages/insurrance-online',
	formInsurance: '/pages/insurrance-online/form-insurance',
	confirmInsuranceInfo: '/pages/insurrance-online/confirm-insurance-info',
	paymentMethod: '/pages/insurrance-online/payment-method',

	//menu
	contractQuery: '/pages/contract-query',
	loyaltyStore: '/pages/loyalty-store',
	//gift
	pointRank: '/pages/point-rank',
	//help
	helpCenter: '/pages/open-help-center',
	updatepPassword: '/pages/update-password',
};